class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this._isLoaded = false;
  }

  connectedCallback() {
    this._loadRecommendations();
  }

  hideSectionWrapper() {
    const wrapper = this.closest('[data-product-recommendations-wrapper]');
    if (wrapper) {
      wrapper.classList.add('hidden');
    } else {
      let parent = this.parentElement;
      while (parent && parent !== document.body) {
        if (parent.classList.contains('px-4') || parent.classList.contains('mt-8')) {
          parent.classList.add('hidden');
          break;
        }
        parent = parent.parentElement;
      }
    }
  }

  async _loadRecommendations() {
    if (this._isLoaded) {
      return;
    }
    this._isLoaded = true;

    const section = this.closest('.shopify-section');
    if (!section) {
      console.error('[ProductRecommendations] Parent section not found');
      return;
    }

    const productId = this.getAttribute('product');
    const limit = this.getAttribute('limit') || 4;
    const intent = this.getAttribute('intent') || 'complementary';

    if (!productId) {
      console.error('[ProductRecommendations] Product ID not found');
      return;
    }

    const url = `${window.Shopify?.routes?.root || '/'}recommendations/products?product_id=${productId}&limit=${limit}&section_id=product-recommendations&intent=${intent}`;

    try {
      const response = await fetch(url, {
        priority: 'low',
        credentials: 'same-origin',
        headers: {
          'Accept': 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const html = await response.text();

      if (html.trim().length === 0) {
        console.warn('[ProductRecommendations] Empty HTML response');
        this.classList.add('hidden');
        return;
      }

      const tempDiv = new DOMParser().parseFromString(html, 'text/html');

      let sectionElement = tempDiv.querySelector(`#shopify-section-product-recommendations`);
      if (!sectionElement && tempDiv.body) {
        sectionElement = tempDiv.body.querySelector(`#shopify-section-product-recommendations`);
      }

      let productRecommendationsElement = null;
      if (sectionElement) {
        productRecommendationsElement = sectionElement.querySelector('product-recommendations');
      } else {
        productRecommendationsElement = tempDiv.querySelector('product-recommendations');
        if (!productRecommendationsElement && tempDiv.body) {
          productRecommendationsElement = tempDiv.body.querySelector('product-recommendations');
        }
      }

      if (productRecommendationsElement) {
        const hasContent = productRecommendationsElement.querySelector('.flex.flex-col') ||
          productRecommendationsElement.querySelector('.horizontal-product') ||
          (productRecommendationsElement.innerHTML.trim().length > 0 &&
            !productRecommendationsElement.innerHTML.trim().match(/^\s*$/));

        if (hasContent) {
          this.replaceChildren(...document.importNode(productRecommendationsElement, true).childNodes);
          const wrapper = this.closest('[data-product-recommendations-wrapper]');
          if (wrapper) {
            wrapper.classList.remove('hidden');
          }
        } else {
          this.classList.add('hidden');
          this.hideSectionWrapper();
        }
      } else {
        this.classList.add('hidden');
        this.hideSectionWrapper();
      }
    } catch (error) {
      console.error('[ProductRecommendations] Error loading recommendations:', error);
      this.classList.add('hidden');
    }
  }
}

if (!window.customElements.get('product-recommendations')) {
  window.customElements.define('product-recommendations', ProductRecommendations);
}
